/* Import External Modules */
import { format as formatDate, formatISO, formatDistanceToNow, isValid } from 'date-fns';

/**
 * Formats a timestamp.
 * @param {Date} date - Standard date object to format. 
 * @param {String} options.format - Formatting options based off date-fns formatter with extension for iso8610 and fromNow fields.
 */
function format(date, options) {
  if (date == null || !options?.format || !isValid(date)) {
    return ['-'];
  }
  const {
    format
  } = options;
  const formattedDate = format === 'fromNow' ? formatDistanceToNow(date, {
    includeSeconds: true,
    addSuffix: true
  }) : format === 'iso8601' ? formatISO(date) : formatDate(date, format);
  return [formattedDate];
}
export default {
  format
};